import { FC } from 'react';

import useCallbackListener from 'hooks/useCallbackListener';
import useCometChat from 'hooks/useCometChat';
import useCurrentUser from 'hooks/useCurrentUser';
import useIntercom from 'hooks/useIntercom';

const withUser = (Component: FC) => () => {
  useCurrentUser();
  useCallbackListener();
  useCometChat();
  useIntercom();

  return <Component />;
};

export default withUser;
